import React from "react";
import { PersonnelRole } from "@prestosports/prestostats-core/Football";
import EventDetails from "../../common/components/EventDetails";

const roles = Object.values(PersonnelRole).map(({ name, code }) => ({
	name,
	value: code
}));

const GameEventDetails = () => {
	return <EventDetails roles={roles} />;
};

export default GameEventDetails;
